import { types } from "../actions/profile/types";
import { types as uploadSelectionTypes } from "../actions/uploadSelection/types";

const initialState = {
  isLoading: false,
  wardrobeProducts: null,
  isShouldUpdateVault: false,
  weekSelectionProducts: null,
  shopProducts: [],
  savedProducts: [],
  followingBrands: [],
  followingStores: [],
  totalSpins: [],
  homePageWearableContent: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  homePageArtContent: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  productsCount: 0,
  tabKind: "wearables",
  usualTabKind: "vault",
  scrollTop: 0,
  pageNumber: 0,
  givebackData: null,
  productInfo: null,
  isProductOpen: false,
  productToken: "",
  productError: null,
  transactionHistory: null,
  tokenizedBrandInfo: null,
  profileInfo: null,
  profileError: null,
  worldsData: null,
  vouchersData: null,
  certainDiscount: null,
  lastUrl: null,
  galleryImages: null,
  scrollToImageId: null,
  profilesToSwitch: [],
  artsProducts: [],
  artsCount: 0,
  artPageNumber: 0,
  leaderboard: {
    loading: false,
    data: null,
    error: null,
  },
  playerActivity: {
    loading: false,
    data: null,
    error: null,
  },
  allPlayers: {
    loading: false,
    data: null,
    error: null,
  },
  winners: {
    loading: false,
    data: null,
    error: null,
  },
  // Transient UI state for business creation review flow
  businessCreated: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_LEADERBOARD_START:
      return {
        ...state,
        leaderboard: {
          ...state.leaderboard,
          loading: true,
        },
      };

    case types.FETCH_LEADERBOARD_SUCCESS:
      return {
        ...state,
        leaderboard: {
          loading: false,
          data: payload.leaderboardData,
          error: null,
        },
      };

    case types.FETCH_LEADERBOARD_FAILURE:
      return {
        ...state,
        leaderboard: {
          ...state.leaderboard,
          loading: false,
          error: payload.error,
        },
      };

    case types.FETCH_PLAYER_ACTIVITY_START:
      return {
        ...state,
        playerActivity: {
          ...state.playerActivity,
          loading: true,
        },
      };

    case types.FETCH_PLAYER_ACTIVITY_SUCCESS:
      return {
        ...state,
        playerActivity: {
          loading: false,
          data: payload.activityData,
          error: null,
        },
      };

    case types.FETCH_PLAYER_ACTIVITY_FAILURE:
      return {
        ...state,
        playerActivity: {
          ...state.playerActivity,
          loading: false,
          error: payload.error,
        },
      };

    case types.FETCH_ALL_PLAYERS_START:
      return {
        ...state,
        allPlayers: {
          ...state.allPlayers,
          loading: true,
        },
      };

    case types.FETCH_ALL_PLAYERS_SUCCESS:
      return {
        ...state,
        allPlayers: {
          loading: false,
          data: payload.allPlayersData,
          error: null,
        },
      };

    case types.FETCH_ALL_PLAYERS_FAILURE:
      return {
        ...state,
        allPlayers: {
          ...state.allPlayers,
          loading: false,
          error: payload.error,
        },
      };

    case types.FETCH_GAME_WINNERS_START:
      return {
        ...state,
        winners: {
          ...state.winners,
          loading: true,
        },
      };

    case types.FETCH_GAME_WINNERS_SUCCESS:
      return {
        ...state,
        winners: {
          loading: false,
          data: payload.winnersData,
          error: null,
        },
      };

    case types.FETCH_GAME_WINNERS_FAILURE:
      return {
        ...state,
        winners: {
          ...state.winners,
          loading: false,
          error: payload.error,
        },
      };

    case types.FETCH_PROFILE_IS_LOADING:
      return { ...state, isLoading: payload };

    case types.FETCH_WARDROBE_SUCCEEDED:
      return { ...state, wardrobeProducts: payload.products };

    case types.FETCH_WEEK_SELECTION_SUCCEEDED:
      return { ...state, weekSelectionProducts: payload.products };

    case types.FETCH_START_SHOP_PRODUCTS_SUCCEEDED:
      return {
        ...state,
        shopProducts: payload.productsData.products,
        productsCount: payload.productsData.products_count,
        scrollTop: 0,
        pageNumber: 0,
      };

    case types.FETCH_START_ARTS_PRODUCTS_SUCCEED:
      return {
        ...state,
        artsProducts: payload.productsData.products,
        artsCount: payload.productsData.products_count,
        scrollTop: 0,
        artPageNumber: 0,
      };

    case types.FETCH_ARTS_PRODUCTS_SUCCEED:
      return {
        ...state,
        artsProducts: [...state.artsProducts, ...payload.products],
      };

    case types.FETCH_SHOP_PRODUCTS_SUCCEEDED:
      return {
        ...state,
        shopProducts: [...state.shopProducts, ...payload.products],
      };

    case types.FETCH_SAVED_PRODUCTS_AND_UPDATE_SUCCEEDED:
      return {
        ...state,
        savedProducts: [...payload.products],
      };
    case types.FETCH_SAVED_PRODUCTS_AND_ADD_SUCCEEDED:
      return {
        ...state,
        savedProducts: [...state.savedProducts, ...payload.products],
      };

    case types.FETCH_FOLLOWING_BRANDS_SUCCEEDED:
      return {
        ...state,
        followingBrands: [...state.followingBrands, ...payload],
      };

    case types.FETCH_FOLLOWING_STORES_SUCCEEDED:
      return {
        ...state,
        followingStores: [...state.followingStores, ...payload],
      };

    case types.FETCH_SPINS_SUCCEEDED:
      return { ...state, totalSpins: [...state.totalSpins, ...payload] };

    case types.REMOVE_FOLLOWING:
      return { ...state, followingBrands: [], followingStores: [] };

    case types.REMOVE_SAVED:
      return { ...state, savedProducts: [] };

    case types.REMOVE_SPINS:
      return { ...state, totalSpins: [] };

    case types.REMOVE_SHOP_PRODUCTS:
      return { ...state, shopProducts: [] };

    case types.BRAND_TAB_KIND:
      return { ...state, tabKind: payload.tabname };

    case types.USUAL_TAB_KIND:
      return { ...state, usualTabKind: payload.tabname };

    case types.SAVE_SCROLL_STATE:
      return { ...state, scrollTop: payload.scrollState };

    case types.SET_IS_PRODUCT_OPEN:
      return { ...state, isProductOpen: payload.value };

    case types.SET_PAGE_NUMBER:
      return { ...state, pageNumber: payload.pageNumber };

    case types.SET_ARTS_PAGE_NUMBER:
      return { ...state, artPageNumber: payload.pageNumber };

    case types.SET_GIVEBACK_DATA:
      return { ...state, givebackData: payload.data };

    case types.SET_PRODUCT_INFO: {
      const updatedProductInfo = JSON.parse(JSON.stringify(payload.product));
      if (updatedProductInfo) {
        updatedProductInfo.stocks
          .filter((item) => item.size)
          .sort((a, b) => a.size.id > b.size.id);
      }
      return { ...state, productInfo: updatedProductInfo, DPP: payload.DPP, productError: null };
    }

    case types.SET_PRODUCT_ERROR:
      return { ...state, productError: payload.error };

    case types.SET_TRANSACTION_HISTORY:
      return { ...state, transactionHistory: payload.data };

    case types.SET_TOKENIZED_BRAND_INFO:
      return { ...state, tokenizedBrandInfo: payload.data };

    case types.SET_PROFILE_DATA:
      return { ...state, profileInfo: payload.data, profileError: null };

    case types.SET_PROFILE_ERROR:
      return { ...state, profileError: payload.error };

    case types.SET_WORLDS_DATA:
      return { ...state, worldsData: payload.data };

    case types.SET_PRODUCT_TOKEN:
      return { ...state, productToken: payload.token };

    case uploadSelectionTypes.SET_PRODUCT_MEMORY: {
      const updatedTransactions = { ...state.transactionHistory };
      const history = updatedTransactions["0"].history;
      history[history.length - 1].memories.push(payload.memory);
      return { ...state, transactionHistory: updatedTransactions };
    }

    case types.SET_VOUCHERS_DATA: {
      const updatedVouchers = payload.vouchers.map((v) => {
        v.expiration_date = v.expiration_date.split(" ")[0];
        return v;
      });
      return { ...state, vouchersData: updatedVouchers };
    }

    case uploadSelectionTypes.ADD_CREATED_VOUCHER: {
      const newVoucher = { ...payload.voucher };
      newVoucher.expiration_date = newVoucher.expiration_date.split(" ")[0];
      return {
        ...state,
        vouchersData: [newVoucher, ...state.vouchersData],
      };
    }

    case uploadSelectionTypes.SET_EDITED_VOUCHER: {
      const updatedVouchers = JSON.parse(
        JSON.stringify(state.vouchersData)
      ).filter((v) => String(v.id) !== String(payload.id));
      const newVoucher = { ...payload.voucher };
      newVoucher.expiration_date = newVoucher.expiration_date.split(" ")[0];
      return {
        ...state,
        vouchersData: [newVoucher, ...updatedVouchers],
      };
    }

    case uploadSelectionTypes.REMOVE_ACTIVE_VOUCHER: {
      const removedVoucher = state.vouchersData.find(
        (v) => String(v.id) === String(payload.id)
      );
      removedVoucher.is_active = false;
      const updatedVouchers = JSON.parse(
        JSON.stringify(state.vouchersData)
      ).filter((v) => String(v.id) !== String(payload.id));
      return { ...state, vouchersData: [removedVoucher, ...updatedVouchers] };
    }

    case uploadSelectionTypes.MAKE_VOUCHER_ACTIVE: {
      const updatedVouchers = JSON.parse(
        JSON.stringify(state.vouchersData)
      ).filter((v) => String(v.id) !== String(payload.id));
      const newVoucher = { ...payload.voucher };
      newVoucher.expiration_date = newVoucher.expiration_date.split(" ")[0];
      return { ...state, vouchersData: [newVoucher, ...updatedVouchers] };
    }

    case types.SET_DISCOUNT_FOR_CERTAIN_PRODUCT:
      return { ...state, certainDiscount: payload.data };

    case types.DELETE_MEMORY_LOCALLY: {
      const updatedHistory = JSON.parse(
        JSON.stringify(state.transactionHistory)
      );
      const historyItemIndex = updatedHistory[0].history
        .map((h) => h.slug)
        .indexOf(payload.slug);
      updatedHistory[0].history[
        historyItemIndex
      ].memories = updatedHistory[0].history[historyItemIndex].memories.filter(
        (m) => +m.id !== +payload.id
      );
      return { ...state, transactionHistory: updatedHistory };
    }
    case types.SHOULD_UPDATE_VAULT:
      return { ...state, isShouldUpdateVault: payload.value };

    case types.SET_GALLERY_IMAGES:
      return { ...state, galleryImages: payload.images };
    case types.SET_GALLERY_IMAGE_ID_TO_SCROLL:
      return { ...state, scrollToImageId: payload.value };

    case uploadSelectionTypes.REMOVE_PASSEDON_PRODUCT: {
      const updatedVault = state.wardrobeProducts?.filter(
        (pr) => pr.passon_link !== payload.passonLink
      );
      return { ...state, wardrobeProducts: updatedVault };
    }

    case types.SET_PROFILES_TO_SWITCH_POPUP: {
      return { ...state, profilesToSwitch: payload.data };
    }

    // Business profile creation transient state
    case types.SET_BUSINESS_CREATED: {
      return { ...state, businessCreated: payload.res };
    }
    case types.CLEAR_BUSINESS_CREATED: {
      return { ...state, businessCreated: null };
    }
    case types.RESET_TAB_SELECTION_STATE: {
      return { ...state, tabKind: "wearables", usualTabKind: "vault" };
    }

    case types.FETCH_WEARABLE_DATA_ASYNC:
      if (payload.page.results) {
        return {
          ...state,
          homePageWearableContent: {
            ...payload.page,
            results: [
              ...state.homePageWearableContent.results,
              ...payload.page.results,
            ],
          },
        };
      }
    case types.FETCH_ART_DATA_ASYNC:
      if (payload.page.results) {
        return {
          ...state,
          homePageArtContent: {
            ...payload.page,
            results: [
              ...state.homePageArtContent.results,
              ...payload.page.results,
            ],
          },
        };
      }

    case types.SET_TOKEN_TAG_GAME_STATUS:
      return {
        ...state,
        productInfo: state.productInfo
          ? {
              ...state.productInfo,
              token_tag_game: {
                ...state.productInfo.token_tag_game,
                ...payload,
              },
            }
          : null,
      };

    case types.RESET_PROFILE_PAGE:
      return {
        ...state,
        profileInfo: null,
        profileError: null,
        wardrobeProducts: null,
        artsProducts: [],
        shopProducts: [],
        productsCount: 0,
        artsCount: 0,
        isLoading: false, // Reset loading state too
        // Ensure to clear any other profile-specific data that correlates to the "viewed" user
        followingBrands: [],
        followingStores: [],
        totalSpins: [],
      };

    case types.UPDATE_SWITCHABLE_PROFILE_STATUS: {
      const updatedProfiles = state.profilesToSwitch.map((profile) => ({
        ...profile,
        connected: profile.slug === payload.slug,
      }));
      return { ...state, profilesToSwitch: updatedProfiles };
    }

    default:
      return { ...state };
  }
};
